import Vue from 'vue'
import Vuex from 'vuex'


import local from './modules/local'
import misc from './modules/misc'
import setting from './modules/setting'
import navigator from './modules/navigator'
import call from './modules/call'
import item from './modules/item'
import cart from './modules/cart'
import order from './modules/order'

Vue.use(Vuex)

/**
  mining cart app のメインとなるstoreオブジェクト
  必要なstateやmutationは機能毎のmoduleファイルに分割する
*/
export default new Vuex.Store({
  modules: {
    navigator,
    setting,
    misc,
    local,
    call,
    item,
    cart,
    order,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js